import { format } from "date-fns";
import uniqueId from "utils/generateId";
import Mock from "./mock";

// Helper function to create region data
const createRegionData = (name, revenue = "45") => ({
  id: uniqueId(),
  name: name,
  position: `${revenue}K Revenue`,
  //  experience: "This Month",
  referralPass: `${Math.floor(Math.random() * 3 + 6)} Passes`,
  email: `${Math.floor(Math.random() * 4 + 4)} Completed`,
  phone: `${Math.floor(Math.random() * 2 + 1)} Scheduled`,
  chapters: `${Math.floor(Math.random() * 2 + 2)} Chapters`
});

export const tableData1 = [{
  id: uniqueId(),
  avatar: "/static/avatar/001-man.svg",
  name: "Zachary Gomez",
  username: "zachary-gomez",
  email: "zachary-gomez@gmail.com",
  role: "Editor"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/002-girl.svg",
  name: "Amanda Montgomery",
  username: "amanda-montgomery",
  email: "montgomery@ya.com",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/003-boy.svg",
  name: "Lester Holland",
  username: "lester-holland",
  email: "lester75@gmail.com",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/004-woman.svg",
  name: "Max Allison",
  username: "max-allison",
  email: "max-allison@pochta.io",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/005-man-1.svg",
  name: "Richard Gregory",
  username: "r.gregory",
  email: "gregory@gmail.com",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/006-woman-1.svg",
  name: "Clifford Caldwell",
  username: "clifford-caldwell",
  email: "clifford-c@gmail.com",
  role: "Author"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/007-boy-1.svg",
  name: "Lester Holland",
  username: "zlester-holland",
  email: "lester75@gmail.com",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/008-clown.svg",
  name: "Richard Gregory",
  username: "r.gregory",
  email: "gregory@gmail.com",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/009-firefighter.svg",
  name: "Max Allison",
  username: "max-allison",
  email: "max-allison@pochta.io",
  role: "Subscriber"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/010-girl-1.svg",
  name: "Zachary Gomez",
  username: "zachary-gomez",
  email: "zachary-gomez@gmail.com",
  role: "Editor"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/011-man-2.svg",
  name: "Zachary Gomez",
  username: "zachary-gomez",
  email: "zachary-gomez@gmail.com",
  role: "Editor"
}, {
  id: uniqueId(),
  avatar: "/static/avatar/012-woman-2.svg",
  name: "Zachary Gomez",
  username: "zachary-gomez",
  email: "zachary-gomez@gmail.com",
  role: "Editor"
}];
Mock.onGet("/api/tableData1/all").reply(() => {
  return [200, tableData1];
});
Mock.onPost("/api/tableData1/new").reply(config => {
  const {
    name,
    username,
    email,
    role
  } = JSON.parse(config.data);
  const newData = {
    role,
    name,
    email,
    username,
    id: uniqueId(),
    avatar: "/static/avatar/012-woman-2.svg"
  };
  tableData1.push(newData);
  return [200, tableData1];
});
Mock.onPost("/api/tableData1/delete").reply(config => {
  const {
    ids
  } = JSON.parse(config.data);
  const filterTable = tableData1.filter((data, index) => data.id !== ids[index]);
  return [200, filterTable];
});

export const tableData2 = [
  {
    id: "eea3-d033-464b-7809",
    name: "North District",
    position: "75K Revenue",
    // //  experience: "This Month",
    referralPass: "12 Passes",
    email: "8 Completed",
    //  phone: "2 Scheduled",
    regions: "3 Regions, 15 Chapters, 20 Members",
    regionDetails: [
      {
        id: "7a33-cddc-d1e5-8e8e",
        name: "North Central Region",
        position: "48K Revenue",
        // //  experience: "This Month",
        referralPass: "8 Passes",
        email: "6 Completed",
        phone: "1 Scheduled",
        chapters: "2 Chapters"
      },
      {
        id: "767b-1316-c42d-e2e1",
        name: "North East Region",
        position: "48K Revenue",
        // //  experience: "This Month",
        referralPass: "8 Passes",
        email: "8 Completed",
        phone: "1 Scheduled",
        chapters: "4 Chapters"
      },
      {
        id: "8d65-81e8-2122-23d6",
        name: "North West Region",
        position: "58K Revenue",
        // //  experience: "This Month",
        referralPass: "9 Passes",
        email: "8 Completed",
        //  phone: "2 Scheduled",
        chapters: "4 Chapters"
      }
    ]
  },
  {
    id: "4e36-f142-2089-c985",
    name: "South District",
    position: "92K Revenue",
    // //  experience: "This Month",
    referralPass: "15 Passes",
    email: "10 Completed",
    phone: "3 Scheduled",
    regions: "4 Regions, 24 Chapters",
    regionDetails: [
      {
        id: uniqueId(),
        name: "South Central Region",
        position: "52K Revenue",
        // //  experience: "This Month",
        referralPass: "8 Passes",
        email: "7 Completed",
        //  phone: "2 Scheduled",
        chapters: "6 Chapters"
      },
      {
        id: uniqueId(),
        name: "South East Region",
        position: "48K Revenue",
        // //  experience: "This Month",
        referralPass: "7 Passes",
        email: "6 Completed",
        phone: "1 Scheduled",
        chapters: "5 Chapters"
      },
      {
        id: uniqueId(),
        name: "South West Region",
        position: "55K Revenue",
        // //  experience: "This Month",
        referralPass: "9 Passes",
        email: "8 Completed",
        //  phone: "2 Scheduled",
        chapters: "7 Chapters"
      },
      {
        id: uniqueId(),
        name: "South Coast Region",
        position: "50K Revenue",
        // //  experience: "This Month",
        referralPass: "8 Passes",
        email: "7 Completed",
        phone: "1 Scheduled",
        chapters: "6 Chapters"
      }
    ]
  },
  {
    id: uniqueId(),
    name: "East District",
    businessDone: "68K",
    referralPass: "10 Passes",
    oneToOne: "7 Meetings",
    regions: "15",
    chapters: "4 Active",
    position: "68K Revenue",
    // //  experience: "This Month",
    email: "7 Completed",
    //  phone: "2 Scheduled"
  },
  {
    id: uniqueId(),
    name: "West District",
    businessDone: "83K",
    referralPass: "14 Passes",
    oneToOne: "9 Meetings",
    regions: "7",
    chapters: "5 Active",
    position: "83K Revenue",
    //  experience: "This Month",
    email: "9 Completed",
    phone: "1 Scheduled"
  },
  {
    id: uniqueId(),
    name: "Central District",
    businessDone: "95K",
    referralPass: "16 Passes",
    oneToOne: "11 Meetings",
    regions: "3",
    chapters: "7 Active",
    position: "95K Revenue",
    //  experience: "This Month",
    email: "11 Completed",
    phone: "3 Scheduled"
  },
  {
    id: uniqueId(),
    name: "Northwest District",
    businessDone: "71K",
    referralPass: "11 Passes",
    oneToOne: "8 Meetings",
    regions: "5",
    chapters: "4 Active",
    position: "71K Revenue",
    //  experience: "This Month",
    email: "8 Completed",
    //  phone: "2 Scheduled"
  },
  {
    id: uniqueId(),
    name: "Southeast District",
    businessDone: "88K",
    referralPass: "13 Passes",
    oneToOne: "9 Meetings",
    regions: "12",
    chapters: "6 Active",
    position: "88K Revenue",
    //  experience: "This Month",
    email: "9 Completed",
    //  phone: "2 Scheduled"
  },
  {
    id: uniqueId(),
    name: "Northeast District",
    businessDone: "79K",
    referralPass: "12 Passes",
    oneToOne: "8 Meetings",
    regions: "11",
    chapters: "5 Active",
    position: "79K Revenue",
    //  experience: "This Month",
    email: "8 Completed",
    phone: "1 Scheduled"
  },
  {
    id: uniqueId(),
    name: "Southwest District",
    businessDone: "86K",
    referralPass: "14 Passes",
    oneToOne: "10 Meetings",
    regions: "4",
    chapters: "6 Active",
    position: "86K Revenue",
    //  experience: "This Month",
    email: "10 Completed",
    //  phone: "2 Scheduled"
  },
  {
    id: uniqueId(),
    name: "Coastal District",
    businessDone: "91K",
    referralPass: "15 Passes",
    oneToOne: "11 Meetings",
    regions: "8",
    chapters: "7 Active",
    position: "91K Revenue",
    //  experience: "This Month",
    email: "11 Completed",
    phone: "3 Scheduled"
  }
];
Mock.onGet("/api/tableData2/all").reply(() => {
  return [200, tableData2];
});
Mock.onPost("/api/tableData2/new").reply(config => {
  const {
    name,
    businessDone,
    referralPass,
    oneToOne,
    regions,
    chapters,
    position,
    experience,
    email,
    phone
  } = JSON.parse(config.data);
  
  const newObj = {
    id: uniqueId(),
    name,
    businessDone,
    referralPass,
    oneToOne,
    regions,
    chapters,
    position,
    experience,
    email,
    phone
  };
  
  tableData2.push(newObj);
  return [200, tableData2];
});
Mock.onPost("/api/tableData2/delete").reply(config => {
  const { ids } = JSON.parse(config.data);
  const filterTable = tableData2.filter((data, index) => data.id !== ids[index]);
  return [200, filterTable];
});

// Add region-specific API endpoints
Mock.onGet("/api/tableData2/regions/:districtId").reply(config => {
  const districtId = config.url.split("/").pop();
  const district = tableData2.find(d => d.id === districtId);
  return [200, district ? district.regionDetails : []];
});

Mock.onPost("/api/tableData2/regions/new").reply(config => {
  const { districtId, regionData } = JSON.parse(config.data);
  const district = tableData2.find(d => d.id === districtId);
  if (district) {
    const newRegion = {
      id: uniqueId(),
      ...regionData
    };
    district.regionDetails.push(newRegion);
    district.regions = district.regionDetails.length.toString();
    return [200, district.regionDetails];
  }
  return [404, { message: "District not found" }];
});